/**
 * Pure entrance rule (AVS-4405 Dealer ID selection adjustment). No storage, state or `user`
 * imports: reusable by AVS-4407/4408.
 */

export interface IEntranceSignals {
  navigationType: string | undefined;
  referrer: string;
  origin: string;
}

function parseOrigin(referrer: string): string | undefined {
  if (!referrer) return undefined;

  try {
    return new URL(referrer).origin;
  } catch {
    return undefined;
  }
}

/**
 * `reload` or `back_forward` are never an entrance. A `navigate` whose referrer is this document's
 * own origin is an internal full-page load, not an entrance either. Everything else is an
 * entrance: an empty referrer, another origin (including another subdomain), an unparsable
 * referrer, or a missing/unknown navigation type such as `prerender` (fallback).
 */
export function isNewEntrance({ navigationType, referrer, origin }: IEntranceSignals): boolean {
  if (navigationType === 'reload' || navigationType === 'back_forward') {
    return false;
  }

  if (navigationType === 'navigate' && parseOrigin(referrer) === origin) {
    return false;
  }

  return true;
}

/** True when the stored choice changed while a bfcache-restored page sat hidden. */
export function shouldReloadRestoredPage(choiceWhenHidden: string | undefined, choiceNow: string | undefined): boolean {
  return choiceWhenHidden !== choiceNow;
}
